export default class NewsAndEvents {
	constructor(config) {
		this.el = config.el || document.querySelectorAll(".news-and-events");
		this.carouselContainer = this.el.querySelector(
			".news-and-events__carousel"
		);
		this.thumbs = this.el.querySelector(".carousel__controls");
		this.carousel = this.el.querySelectorAll(".news-and-events__carousel");
		this.carouselItems = this.el.querySelectorAll(".js-carousel__item");
		this.links = this.el.querySelectorAll(".js-carousel__item a");
		this.dots = [];

		this.init();
	}

	init() {
		const self = this;
		self.createNavigation();
		self.attachEvents();
		this.checkDots();
		this.checkOverlappingElements();
	}

	createNavigation() {
		const self = this;
		//create carousel navigation
		if (this.carouselItems && this.carouselItems.length > -1) {
			this.carouselItems.forEach(item => {
				var ids = item.id;
				var kultunautEventClass = item.classList.contains(
					"kultunautEventFeedItem"
				)
					? "controls__dot--kultunaut"
					: "";
				self.thumbs.innerHTML +=
					"<button tabindex='-1' data-id='" +
					ids +
					"' aria-hidden='true' class='controls__dot " +
					kultunautEventClass +
					"'></button>";
			});
		}

		//add current class
		var controlDot = this.thumbs.querySelectorAll(".controls__dot");
		if (controlDot && controlDot[0]) {
			var controlDotFirst = controlDot[0];
			controlDotFirst.className += " current__dot";
		}
		// store globally in component
		this.dots = this.el.querySelectorAll(".controls__dot");
	}

	attachEvents() {
		const self = this;

		//check the current item and update navigation dots
		var timer = null;
		this.carouselContainer.addEventListener(
			"scroll",
			event => {
				if (timer !== null) {
					clearTimeout(timer);
				}
				timer = setTimeout(function() {
					const currentDot = self.el.querySelector(".current__dot");
					let itemInView = null;
					let nextDot = null;
					if (currentDot) {
						currentDot.classList.remove("current__dot");
					}

					self.carouselItems.forEach(carouselItem => {
						if (
							self.isElementInViewport(carouselItem) &&
							nextDot == null
						) {
							const nextDotIndex = [
								...carouselItem.parentNode.children
							].indexOf(carouselItem);

							nextDot = self.dots[nextDotIndex];
						}
					});
					if (self.carouselContainer.scrollLeft == 0) {
						self.dots[0].classList.add("current__dot");
					} else if (nextDot) {
						nextDot.classList.add("current__dot");
					}
				}, 150);
			},
			false
		);

		this.links.forEach(link => {
			link.addEventListener("focus", function(event) {
				self.carouselContainer.scrollLeft = link.parentNode.offsetLeft;
				let scrollTop =
					window.pageYOffset || document.documentElement.scrollTop;
				window.scrollTo(
					0,
					link.parentNode.getBoundingClientRect().top + scrollTop
				);
			});
		});

		// Add button click eventListener
		for (let i = 0; i < self.dots.length; i++) {
			self.dots[i].addEventListener("click", function() {
				var elem = self.carouselItems[i];
				self.carouselContainer.scrollLeft = elem.offsetLeft;
			});
		}

		window.addEventListener(
			"resize",
			function() {
				self.checkDots();
				self.checkOverlappingElements();
			},
			true
		);
	}
	checkDots() {
		if (this.dots && this.dots.length > 0) {
			this.dots.forEach(element => {
				element.classList.remove("hidden");
			});
			if (window.innerWidth >= 668) {
				// remove last dot when not equal count + 2 visible cards
				if (this.dots.length > 2) {
					this.dots[this.dots.length - 1].classList.add("hidden");
				}
				if (this.dots.length == 2) {
					this.dots[this.dots.length - 1].classList.add("hidden");
					this.dots[this.dots.length - 2].classList.add("hidden");
				}
			}
		}
	}
	isElementInViewport(el) {
		var rect = el.getBoundingClientRect();
		return (
			rect.left >= 0 &&
			rect.right <=
				(window.innerWidth || document.documentElement.clientWidth)
		);
	}

	checkOverlappingElements() {
		let controls = this.el.querySelector(".carousel__controls");
		let title = this.el.querySelector(".section__title");
		if (title && controls) {
			const rect1 = title.getBoundingClientRect();
			const rect2 = controls.getBoundingClientRect();

			if (
				!(
					rect1.right < rect2.left ||
					rect1.left > rect2.right ||
					rect1.bottom < rect2.top ||
					rect1.top > rect2.bottom
				)
			) {
				title.classList.add("mb-xs-2");
				title.classList.add("mb-sm-2");
			} else {
				title.classList.remove("mb-sm-2");
				title.classList.remove("mb-xs-2");
			}
		}
	}
}
